import { Link, Navigate, NavLink, Route, Routes, useLocation, useParams } from "react-router-dom";
import { useMe, type Me } from "./lib/useMe";
import { authClient } from "./lib/auth";
import { Board } from "./board/Board";
import { LoginPage } from "./pages/Login";
import { ProjectsPage } from "./pages/Projects";
import { SettingsPage } from "./pages/Settings";
import { TeamPage } from "./pages/Team";
import { InvitePage } from "./pages/Invite";
import { ProfilePage } from "./pages/Profile";

export function App() {
  const { me, loading, refresh } = useMe();
  const loc = useLocation();
  if (loading) return <div className="center muted">Loading…</div>;
  if (!me) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage onSignedIn={refresh} />} />
        <Route path="*" element={<Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Navigate to={new URLSearchParams(loc.search).get("next") || "/"} replace />} />
      <Route path="/p/:id" element={<BoardRoute />} />
      <Route path="*" element={<Shell me={me}>
        <Routes>
          <Route path="/" element={<ProjectsPage me={me} />} />
          <Route path="/p/:id/settings" element={<SettingsPage />} />
          <Route path="/team" element={<TeamPage me={me} onChanged={refresh} />} />
          <Route path="/invite/:id" element={<InvitePage onAccepted={refresh} />} />
          <Route path="/profile" element={<ProfilePage me={me} onChanged={refresh} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>} />
    </Routes>
  );
}

function BoardRoute() {
  const { id } = useParams();
  return <Board projectId={id!} toolbarLeft={
    <span style={{ display: "flex", gap: 12, alignItems: "center", fontSize: 13 }}>
      <Link to="/">← Projects</Link>
      <Link to={`/p/${id}/settings`}>Settings</Link>
    </span>
  } />;
}

function Shell({ me, children }: { me: Me; children: React.ReactNode }) {
  return (
    <>
      <div className="topbar">
        <span className="brand">SUPER GANTT</span>
        <nav>
          <NavLink to="/" end>Projects</NavLink>
          <NavLink to="/team">Team</NavLink>
        </nav>
        <span className="spacer" />
        <NavLink to="/profile" className="muted" style={{ fontSize: 14 }}>{me.user.name || me.user.email}</NavLink>
        <button className="btn" onClick={async () => { await authClient.signOut(); window.location.href = "/login"; }}>Sign out</button>
      </div>
      <div className="page">{children}</div>
    </>
  );
}
